import {
  useAllDocksQuery,
  useAllSkusQuery,
  useDispatchListLazyQuery,
} from "generated/graphql"
import { useSearchFilter } from "hooks/searchFilterHooks"
import { useEffect } from "react"
import { useCurrentDc } from "store/auth.redux"

export const useDispatchList = () => {
  const [dc] = useCurrentDc()
  const [{ date, search, page }] = useSearchFilter()
  const [getDispatches, response] = useDispatchListLazyQuery()

  useEffect(() => {
    getDispatches({
      variables: {
        first: 15,
        skip: page * 15,
        date,
        query: search,
        distributionCentreId: dc?.id,
      },
    })
  }, [dc, date, getDispatches, search, page])
  return response
}

export const useAllDocksList = () => {
  const { data } = useAllDocksQuery()
  return data?.allDocks
}

export const useAllSkusList = () => {
  const { data } = useAllSkusQuery()
  return data?.allSkuTypes
}
